export const FETCH_COREVALUE_REQUEST = 'FETCH_COREVALUE_REQUEST';
export const FETCH_COREVALUE_SUCCESS = 'FETCH_COREVALUE_SUCCESS';
export const FETCH_COREVALUE_FAILURE = 'FETCH_COREVALUE_FAILURE';
export const CREATE_COREVALUE_REQUEST = 'CREATE_COREVALUE_REQUEST';
export const CREATE_COREVALUE_SUCCESS = 'CREATE_COREVALUE_SUCCESS';
export const CREATE_COREVALUE_FAILURE = 'CREATE_COREVALUE_FAILURE';
